import './App.css';
import { Stage } from '@pixi/react';
import { observer } from 'mobx-react-lite';
import { GameModule } from './gameModule';
import { isMobile } from './helpers/isMobile';
import { useEffect, useLayoutEffect, useRef } from 'react';
import { parseQuery } from './helpers/parseQuery';
import { Frame } from 'pascal-slots-core';
import { gameControlService } from './gameModule/services/gameControlService';
import { configuratedStage } from './helpers/configuratedStage';
import { stageOptions } from './constants/gameConstants';
import { gameConfigurationStore } from './gameModule/store/gameConfigurationStore';
import { googleAnalyticsTokensByGame } from './constants/enumsByGames';


export const App = observer(() => {
  const refApp = useRef(null);
  const query = parseQuery(window.location.search);
  const { gameConfigurationisReady, gameConfiguration, createGameConfigurationTree } = gameConfigurationStore

  useLayoutEffect(() => {
    configuratedStage(refApp);
    createGameConfigurationTree(query)
  }, [])

  useEffect(() => {
    if (process.env.REACT_APP_ENV === 'production') {
      console.log(query.gameid);
      
      const token = googleAnalyticsTokensByGame[query.gameid]
      const script = document.createElement('script')
      script.src = `https://www.googletagmanager.com/gtm.js?id=${token}`
      script.async = true
      window.hj = window.hj || function () {
        (window.hj.q = window.hj.q || []).push(arguments)
      };
      window['dataLayer'] = window['dataLayer'] || [];
      window['dataLayer'].push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js',
      });
      const f = document.getElementsByTagName('script')[0]
      f.parentNode.insertBefore(script, f);
    }

  }, [])


  return (
    <div className={isMobile() ? 'canvas-wrapper' : 'canvas-web-wrapper'}>
      <Stage
        ref={refApp}
        width={isMobile() ? window.innerWidth : 1440}
        height={isMobile() ? window.innerHeight : 810}
        options={stageOptions}>
        {gameConfigurationisReady && <Frame queryParams={query} gameConfig={gameConfiguration} gameControlService={gameControlService}>
          <GameModule />
        </Frame>}
      </Stage>
    </div>
  );
})
